import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
import { PreviewMapComponent } from 'src/app/kehadiran-detail/preview-map/preview-map.component';
import { ApiService } from 'src/app/services/api.service';
import { UtilService } from 'src/app/services/util/util.service';

@Component({
  selector: 'app-detail-hasil-survey',
  templateUrl: './detail-hasil-survey.component.html',
  styleUrls: ['./detail-hasil-survey.component.css']
})
export class DetailHasilSurveyComponent implements OnInit {

 
  kw: any;
  load: boolean = false;
  hasilX: any = {};

  cabang: any = '';
  surveyor: any = '';
nama: any = '';
aa: any = [];
status: any = '';
is_forever: boolean = false;
is_foreverText: string = 'N';
datax: any = {}


  constructor(
    public navParams: NavParams,
    public api: ApiService,
    public util: UtilService,
    public modalController: ModalController,
  ) { 
    try {
      this.datax = JSON.parse(this.navParams.data.datax);
      console.log('KW', this.datax);
    } catch (error) {
      // this.util.showToast('Data Lead_id tidak terparsing', 'danger', 'bottom');
    }
  }

  ngOnInit(): void {

  }

  batal(){
    this.api.dismiss();
  }

  async prevMap() {
      let id = {
        latitude: this.datax.details?.lat,
        longitude: this.datax.details?.lng
      }
        const modal = await this.modalController.create({
          component: PreviewMapComponent,
          cssClass: 'modalMaps',
          componentProps: {
            id: id
          }
        });
        modal.onDidDismiss()
          .then((data: any) => {
            if (data.role === 'confirm') {
              // this.ionViewWillEnter();
            }
          });
        return await modal.present();
      }


}
